<template>
  <div :title="`${action_name} ${module_name}`" button-accept="false" button-cancel="false" :active.sync="isActive">
    <div class="mb-4 flex items-center">
      <vs-button @click="isActive = false" color="dark" type="filled" icon-pack="feather" icon="icon-arrow-left"> Back </vs-button>
    </div>
    <form method="POST" @submit.prevent="save_changes">
      <!-- Gurudwara Name -->
      <div class="mb-3">
        <div class="flex w-1/2">
          <div class="w-1/3">
            <vs-input icon-pack="feather" v-validate="'required'" v-model="label" label="Month Name *" placeholder="Langar" name="Month Name" id="Month Name" disabled />
            <span class="text-danger text-sm" v-show="errors.has('Month Name')">{{ errors.first('Month Name') }}</span>
          </div>
          <div v-if="isEditable" class="flex justify-center items-center" style="margin-top: 28px">
            <vs-button @click="addData('details')" color="primary" size="default"> <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" /> Add New Daily Routine</vs-button>
          </div>
        </div>
      </div>

      <div>
        <!-- Daily Routine Section -->
        <div class="w-full">
          <vs-divider></vs-divider>
          <div class="flex gap-4 items-center">
            <div class="flex items-center text-center">
              <h3 class="text-xl mb-4 mt-5">Daily Routine</h3>
            </div>
            <vs-button v-if="form.details.length > 0" @click="copyToAllDailyRoutine" color="primary" size="default"> Copy to All Months</vs-button>
          </div>
          <vs-divider></vs-divider>

          <div>
            <div v-for="(dailyReadingValue, index) in form.details" :key="index" class="sarai-entry flex flex-wrap justify-between border-sky-500 border">
              <!-- Container for the fields in a single row -->
              <div class="w-full flex items-center justify-between m-0">
                <div class="w-full">
                  <div class="w-4/5 px-2 mb-4">
                    <vs-input
                      icon-pack="feather"
                      type="text"
                      v-validate="'required|exclude_special_char'"
                      data-vv-as="Name"
                      v-model="dailyReadingValue.title"
                      label="Name *"
                      min="1"
                      placeholder="Kirtan at Amrit Vela ( Early dawn )"
                      :name="'daily_routine_' + index"
                      class="w-full"
                      :disabled="!isEditable"
                    />
                    <span class="text-danger text-sm" v-show="errors.has(`daily_routine_${index}`)">{{ errors.first(`daily_routine_${index}`) }}</span>
                  </div>
                  <div class="w-4/5 px-2">
                    <label>Timing</label>
                    <div>
                      <flat-pickr
                        :config="configdateTimePicker"
                        v-model="dailyReadingValue.time"
                        name="Timing"
                        placeholder="Timing"
                        class="form-control dropdown-color hours-dropdown mt-1"
                        id="Timing"
                        v-validate="'required'"
                        :disabled="!isEditable"
                      />
                    </div>
                    <span class="text-danger text-sm" v-show="errors.has('Timing')">{{ errors.first('Timing') }}</span>
                  </div>
                </div>
                <div class="">
                  <vx-tooltip :text="`Remove Daily Routine`" v-if="isEditable">
                    <vs-button @click="removeData('details', index)" color="danger" type="gradient" icon-pack="feather" icon="icon-trash-2" />
                  </vx-tooltip>
                </div>
              </div>

              <vs-divider></vs-divider>
            </div>
          </div>
        </div>
      </div>

      <!-- Save & Reset Button -->
      <div class="">
        <div class="vx-col w-full">
          <div class="flex flex-wrap justify-between">
            <div>
              <vs-button class="mr-2 vs-con-loading__container" id="update-daily-routine" @click="save_changes" v-if="isEditable">Save Changes</vs-button>
              <vs-button color="danger" @click="navigateList" class="text-white-500">Cancel</vs-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import 'flatpickr/dist/flatpickr.css'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  /** Page Name */
  name: 'AddUpdate',

  components: {
    flatPickr,
    moment
  },

  /** Props */
  props: {
    selectedRecordId: String,
    module_name: String,
    action_name: String,
    showModal: Boolean
  },

  /** data */
  data() {
    return {
      label: null,
      form: {
        details: []
      },
      configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'h:i K'
      }
    }
  },

  /** computed */
  computed: {
    ...mapState('gurudwara', ['createLoading']),
    ...mapGetters('auth', ['checkPermissionSlug']),
    validateForm() {
      return !this.errors.any()
    },
    isEditable() {
      return this.checkPermissionSlug('daily_routine_edit')
    },
    isActive: {
      get() {
        return this.showModal
      },
      set(val) {
        this.$emit('update:showModal', val)
      }
    }
  },

  /** created */
  async created() {
    if (this.$route.params.id) {
      const data = {
        gurudwara: this.$route.params.id,
        routine_month: this.selectedRecordId
      }
      await this.$store.dispatch('gurudwara/dailyRoutineShow', data).then(async (res) => {
        const data = res.data
        /* form variable */
        this.label = data.month.month_name
        this.form.gurudwara = data.gurudwara
        this.form.details = data.data.details ? data.data.details : []
      })
    }
  },

  /** methods */
  methods: {
    ...mapActions('gurudwara', {
      update: 'dailyRoutineUpdate',
      multipleUpdate: 'dailyRoutineMultipleUpdate'
    }),
    navigateList() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Cancel`,
        text: `Are you sure you want to cancel?`,
        accept: () => {
          this.isActive = false
        },
        acceptText: 'Yes',
        cancelText: 'No'
      })
    },

    async copyToAllDailyRoutine() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        this.form.gurudwara = this.$route.params.id

        const response = await this.multipleUpdate({
          data: this.form
        })
        this.$vs.notify({
          title: 'Success',
          text: response.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },

    async save_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        let response
        if (this.selectedRecordId) {
          this.form.gurudwara = this.$route.params.id
          this.form.routine_month = this.selectedRecordId

          response = await this.update({
            data: this.form
          })
        }
        this.isActive = false
        // this.$router.push(`/gurudwara/${this.$route.params.id}/daily-routine-list`)
        this.$emit('update-data', true)
        this.$vs.notify({
          title: 'Success',
          text: response.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },

    /** add data in array */
    addData(type) {
      switch (type) {
      case 'details':
        this.form.details.push({
          title: '',
          time: ''
        })
        break
      default:
        break
      }
    },

    /** remove data from array */
    removeData(type, index) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete?`,
        accept: () => {
          switch (type) {
          case 'details':
            this.form.details.splice(index, 1)
            break
          default:
            break
          }
        },
        acceptText: 'Delete'
      })
    }
  },

  /** watch */
  watch: {
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#update-daily-routine',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#update-daily-routine > .con-vs-loading')
      }
    }
  }
}
</script>
